import RevenueByAssets from "./Pages/Earnings/RevenueByAssets";
import RevenueUpload from "./Pages/Earnings/RevenueUpload";
import PromoRevenueUpload from "./Pages/Earnings/PromoRevenueUpload";
import StaffList from "./Pages/StaffManagement/StaffList";
import InformationPannel from "./Pages/User Pannel/Dash Board/InformationPannel";
import AssetTable from "./Pages/User Pannel/Ingested Assets/AssetSheet";
import VideoUploader from "./Pages/VideoManagement/Upload Videos/UploadVideo";
import WhiteListing from "./Pages/User Pannel/White Listing/WhiteListing";
import VideoPreview from "./Pages/VideoManagement/VideoPreview";
import UsersEarnings from "./Pages/Earnings/UsersEarnings.js";
import Index from "./Pages/YoutubeManagement/Index";
import VideosPreview from "./Pages/YoutubeManagement/VideosPreview";
import PromoChannels from "./Pages/Promo/PromoChannels";
import PromoCompilations from "./Pages/Promo/PromoCompilations";
import CompilationVideos from "./Pages/Promo/CompilationAssets.js";
import TermsofServices from "./Pages/User Pannel/Terms/TermsofServices.js";
import PromoTermsofServices from "./Pages/User Pannel/Terms/PromoTermsofServices.js";
import Dashboard from "./Pages/Promo/Dashboard.js";
import PromoEarnings from "./Pages/Earnings/PromoEarnings.js";
import RevenueByChannel from "./Pages/Earnings/RevenueByChannel.js";
import Library from "./Pages/VideoManagement/Video Library/Library.js";
import LabTabs from "./Pages/YoutubeManagement/mediaScope/mediaScope.js";
import ChannelsPreview from "./Pages/YoutubeManagement/ChannelsPreview.js";
import AppearanceRelease from "./Pages/User Pannel/Terms/ApperanceRelease.js";
import PrivacyPolicy from "./Pages/User Pannel/Terms/PrivacyPolicy.js";
import DropboxPaths from "./Pages/Dropbox/DropboxPaths.js";
import WooglobeSubmition from "./Pages/Wooglobe Submition/WooglobeSubmition.js";
import LibraryDownloads from "./Pages/VideoManagement/Video Library/LibraryDownloads.js";
import AudioManagement from "./Pages/AudioManagement/AudioManagement.js";
import MRSSIndex from "./Pages/MRSSManagement/Index.js";
import BrandsPreview from "./Pages/MRSSManagement/BrandsPreview.js";
import CompilationsPreview from "./Pages/MRSSManagement/CompilationsPreview.js";
import SubbrandsPreview from "./Pages/MRSSManagement/SubbrandsPreview.js";
import FeedsPreview from "./Pages/MRSSManagement/FeedsPreview.js";
import QueuePreview from "./Pages/MRSSManagement/QueuePreview.js";
import BrandPublish from "./Pages/MRSSManagement/BrandPublish/index.js";
import PushToAdminPortal from "./Pages/MRSSManagement/PushToAdminPortal/index.js";
import SocialSchedulersPreview from "./Pages/MRSSManagement/SocialSchedulersPreview.js";



export const admin_urls_pattrens = [
  { url: "/", exact: false, element: <InformationPannel /> },
  { url: "/videos", exact: false, element: <VideoPreview /> },
  { url: "/uploads", exact: false, element: <VideoUploader /> },
  { url: "/dropbox/paths", exact: false, element: <DropboxPaths /> },
  { url: "/video/library", exact: false, element: <Library /> },
  { url: "/video/library/downloads", exact: false, element: <LibraryDownloads /> },
  { url: "/whitelisting", exact: false, element: <WhiteListing /> },
  { url: "/assets", exact: false, element: <AssetTable /> },
  { url: "/staff", exact: false, element: <StaffList /> },
  { url: "/revenue", exact: false, element: <RevenueUpload /> },
  { url: "/promo_revenue", exact: false, element: <PromoRevenueUpload /> },
  { url: "/earning/assets", exact: false, element: <UsersEarnings /> },
  { url: "/earning/assets/:id", exact: false, element: <RevenueByAssets /> },
  { url: "/promo_earning/assets", exact: false, element: <PromoEarnings /> },
  { url: "/earning/promo/:id", exact: false, element: <RevenueByChannel /> },
  { url: "/youtube", exact: false, element: <Index /> },
  { url: "/youtube/channels", exact: false, element: <ChannelsPreview /> },
  { url: "/promo/channels", exact: false, element: <PromoChannels /> },
  { url: "/promo/compilations", exact: false, element: <PromoCompilations /> },
  { url: "/promo/videos/:id", exact: false, element: <CompilationVideos /> },
  { url: "/youtube/list", exact: false, element: <VideosPreview /> },
  { url: "/terms", exact: false, element: <TermsofServices /> },
  { url: "/terms/appereance", exact: false, element: <AppearanceRelease /> },
  { url: "/terms/privacypolicy", exact: false, element: <PrivacyPolicy /> },
  { url: "/promo_terms", exact: false, element: <PromoTermsofServices /> },
  { url: "/mediaScope", exact: false, element: <LabTabs /> },
  { url: "/wooglobe/submition", exact: false, element: <WooglobeSubmition /> },
  { url: "/audio/management", exact: false, element: <AudioManagement /> },
  { url: "/mrss", exact: false, element: <MRSSIndex /> },
  { url: "/mrss/brands", exact: false, element: <BrandsPreview /> },
  { url: "/mrss/compilations", exact: false, element: <CompilationsPreview /> },
  { url: "/mrss/subbrands", exact: false, element: <SubbrandsPreview /> },
  { url: "/mrss/feeds", exact: false, element: <FeedsPreview /> },
  { url: "/mrss/queue", exact: false, element: <QueuePreview /> },
  { url: "/mrss/brand-publish", exact: false, element: <BrandPublish /> },
  { url: "/mrss/push-admin-portal", exact: false, element: <PushToAdminPortal /> },
  { url: "/mrss/social-schedulers", exact: false, element: <SocialSchedulersPreview /> },
];
export const creator_urls_pattrens = [
  { url: "/", exact: false, element: <InformationPannel /> },
  { url: "/videos", exact: false, element: <VideoPreview /> },
  { url: "/uploads", exact: false, element: <VideoUploader /> },
  { url: "/whitelisting", exact: false, element: <WhiteListing /> },
  { url: "/assets", exact: false, element: <AssetTable /> },
  { url: "/earning/assets", exact: false, element: <UsersEarnings /> },
  { url: "/earning/assets/:id", exact: false, element: <RevenueByAssets /> },
  { url: "/promo_earning/assets", exact: false, element: <PromoEarnings /> },
  { url: "/earning/promo/:id", exact: false, element: <RevenueByChannel /> },
  { url: "/terms", exact: false, element: <TermsofServices /> },
  { url: "/terms/appereance", exact: false, element: <AppearanceRelease /> },
  { url: "/terms/privacypolicy", exact: false, element: <PrivacyPolicy /> },
  { url: "/promo_terms", exact: false, element: <PromoTermsofServices /> },
  { url: "/youtube", exact: false, element: <Index /> },
  { url: "/youtube/channels", exact: false, element: <ChannelsPreview /> },
  { url: "/youtube/list", exact: false, element: <VideosPreview /> },
  { url: "/audio/management", exact: false, element: <AudioManagement /> },
];
export const creator_client_urls_pattrens = [
  { url: "/", exact: false, element: <Library /> },
  { url: "/video/library", exact: false, element: <Library /> },
  { url: "/video/library/downloads", exact: false, element: <LibraryDownloads /> },
]
export const promo_urls_pattrens = [
  { url: "/", exact: false, element: <Dashboard /> },
  { url: "/promo/dashboard", exact: false, element: <Dashboard /> },
  { url: "/promo/channels", exact: false, element: <PromoChannels /> },
  { url: "/promo/compilations", exact: false, element: <PromoCompilations /> },
  { url: "/promo/videos", exact: false, element: <CompilationVideos /> },
];
